import React from 'react'
import FooterContent from '../../Component/footers/footerContents/FooterContent'
import Footer from '../../Component/footers/footer/Footer'
const CombineFooter = () => {
  return (
    <div>
      <FooterContent />
      <Footer />
    </div>
  )
}

export default CombineFooter